const schedulerNorwegian = {
  header: {
    title: "LinkedIn Planlegger",
    description: "Angi hvilke dager og tidspunkter LinkedIn-innleggene dine skal sendes."
  },
  limits: {
    scheduled: "Planlagte innlegg: {count}",
    weekly: "Ukentlig grense: {limit}",
    remaining: "Gjenværende: {count}"
  },
  limitWarning: {
    used: "Du har planlagt alle dine {limit} ukentlige innlegg. Oppgrader abonnementet ditt for å få flere.",
    upgrade: "Oppgrader abonnement",
    low: "Du har {remaining} innlegg igjen til planlegging denne uken."
  },
  loading: "Laster inn innstillingene dine...",
  botDelivery: {
    title: "Bot Leveringsplan",
    description: "Angi når du vil motta de ukentlige innleggene fra boten",
    day: "Leveringsdag:",
    time: "Tidspunkt:",
    info: "Den første meldingen kommer {day} kl. {time}. Etterfølgende meldinger kommer når du har akseptert et innlegg."
  },
  postSchedule: {
    title: "LinkedIn Innleggsplan",
    description: "Velg hvilke dager og tidspunkter LinkedIn-innleggene dine skal publiseres",
    days: {
      monday: "Mandag",
      tuesday: "Tirsdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lørdag",
      sunday: "Søndag"
    },
    addTime: "Legg til tidspunkt",
    onePosts: "1 innlegg",
    multiplePosts: "{count} innlegg"
  },
  summary: {
    title: "Oppsummering:",
    description: "LinkedIn-innleggene dine vil bli publisert på følgende tidspunkter:",
    totalPosts: "Totalt planlagte innlegg: {count} av {limit}"
  },
  timeModal: {
    title: "Velg et tidspunkt for {day}",
    label: "Velg tidspunkt:",
    info: "Innlegg på dette tidspunktet vil bli automatisk delt på LinkedIn.",
    cancel: "Avbryt",
    add: "Legg til tidspunkt"
  },
  save: {
    button: "Lagre innstillinger",
    success: "Dine planleggingsinnstillinger er lagret!",
    error: "Det oppstod en feil under lagring av innstillingene dine. Prøv igjen senere."
  },
  timezone: {
    label: "Tidssone:",
    info: "Alle tidspunkter er angitt i tidssonen: {timezone}"
  },
  customerBanner: "Du redigerer planlegging for {customerName}"
};

export default schedulerNorwegian; 